import {
  ADD_ERROR_MESSAGE, ADD_INFO_MESSAGE, CLEAR_MESSAGES, CLOSE_MESSAGE
} from '../../actions';
import { messageTypeValues } from '../../constants/types';

const addInfoMessageToState = (msg, state) =>
  [{
    id: Date.now(), details: [], text: msg, messageType: messageTypeValues.INFO
  }, ...state];

// 401 - Unauthorized is raised to redirect to login page. We don't want to see it.
// 403 - Forbidden is raised to redirect to dedicated error page. We don't want to see it either.
const IGNORED_ERRORS = [401, 403];

const addErrorMessageToState = (err, state) => {
  if (err.status && IGNORED_ERRORS.includes(err.status)) {
    return state;
  }

  const prevError = state.find((m) => m.messageType === messageTypeValues.ERROR) || {
    details: [],
    messageType: messageTypeValues.ERROR,
    text: ''
  };
  const id = Date.now();

  const details = [{
    id,
    code: err.status,
    message: err.statusText || err.message,
    url: err.url
  }, ...prevError.details];
  const error = { ...prevError, id, details };
  const result = [error, ...state.filter((m) => m.messageType !== messageTypeValues.ERROR)];
  return result;
};

export default (state = [], action) => {
  const { type, meta, payload } = action;

  // Errors dispatched by Redux Promise middleware
  if (type.includes('_REJECTED') && !(meta && meta.suppressGlobalErrors)) {
    return addErrorMessageToState(payload, state);
  }
  // Errors dispatched from components
  switch (type) {
    case ADD_ERROR_MESSAGE:
      return addErrorMessageToState(payload, state);
    case ADD_INFO_MESSAGE:
      return addInfoMessageToState(payload, state);
    case CLOSE_MESSAGE:
      return state.filter((msg) => msg.id !== payload);
    case CLEAR_MESSAGES:
      return [];
    default:
      return state;
  }
};
